<template>
  <div>
    <!-- Pay -->
    <a-modal v-model="visible" title="Registered Parent Details" onOk="handleOk"
      :width="this.settings['isMobileView'] ? 360 : this.settings['isTabletView'] ? 560 : 1080"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
      </template>
      <a-spin :spinning="spinning">
      <div class="row">
        <div class="col-md-4">
          <p><span class="pr-2">Parent's Name :</span> <span class="font-weight-bold px-2">{{registeredParent ? registeredParent.name : null}}</span></p>
        </div>
        <div class="col-md-4">
          <p><span class="pr-2">Email :</span> <span class="font-weight-bold px-2">{{registeredParent ? registeredParent.email : null}}</span></p>
        </div>
        <div class="col-md-4">
          <p><span class="pr-2">Phone :</span> <span class="font-weight-bold px-2">{{registeredParent ? registeredParent.phone : null}}</span></p>
        </div>
      </div>
      <hr class="m-0">
        <div class="mb-2 mt-2">
          <p class="h6 text-muted">Children</p>
        </div>
        <table class="table table-borderless">
          <thead class="bg-light">
          <tr>
            <th width="50px">No.</th>
            <th width="100px">Student Code</th>
            <th width="100px">First Name</th>
            <th width="100px">Last Name</th>
            <th width="100px">Roll</th>
            <th width="100px">Class</th>
            <th width="100px">Section</th>
            <th width="100px" class="text-right">Actions</th>

<!--            <th class="text-right">Actions</th>-->
          </tr>
          </thead>
          <tbody>
            <tr v-for="(student, index) in registeredParent ? registeredParent.children : []"
                :key="student.id">
              <td>{{index + 1}}</td>
              <td>{{ student.student_code }}</td>
              <td>{{ student.first_name }}</td>
              <td>{{ student.last_name }}</td>
              <td>{{ student.enrollment[0].roll_no }}</td>
              <td>{{ student.enrollment[0].school_class.name }}</td>
              <td>{{ student.enrollment[0].section.name }}</td>
              <td class="text-right">
                <a-popconfirm
                  title="Are you sure to remove this child?"
                  okText="Yes"
                  cancelText="No"
                  @confirm="handleDeleteChild(student.registered_parents_student_id)"
                >
                <a-button type="danger" size="small" icon="delete">Delete</a-button>
                </a-popconfirm>
              </td>
            </tr>
          </tbody>
        </table>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'RegisteredParentDetails',
  components: {
  },
  props: {
    isPublic: {
      default: false,
    },
    schoolData: {
      default: null,
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      registeredParent: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openViewRegisteredParentDetailsModal', this.showModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    moment,
    showModal: function(registeredParent) {
      console.log('inside openViewRegisteredParentDetailsModal')
      console.log('registeredParent:: ', registeredParent)
      this.visible = true
      // this.spinning = true
      this.registeredParent = registeredParent
    },
    handleDeleteChild(registeredParentsStudentId) {
      this.spinning = true
      this.$http
        .delete(`/api/parent/removechild/${registeredParentsStudentId}`)
        .then(() => {
          this.$notification.success({
            message: 'Child Removed',
            description: 'The child has been successfully removed from this parent.',
          })

          // Update UI instantly (remove from local array)
          this.registeredParent.children = this.registeredParent.children.filter(
            c => c.registered_parents_student_id !== registeredParentsStudentId
          )
        })
        .catch((error) => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.spinning = false
        })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
